/* eslint-disable @typescript-eslint/naming-convention */

import { gql } from "@apollo/client";
import {
  PostInfoV2WithDerivatives,
  UserInfoV2,
  PostCollectionInfoV2,
} from "./fragments";

export const FetchUserTawkOnlyPostsPaginatedV2 = gql`
  ${PostInfoV2WithDerivatives}
  query FetchUserTawkOnlyPostsPaginated(
    $userSub: String!
    $nextPageToken: String
  ) {
    searchPosts(
      filter: {
        ownerSub: { eq: $userSub }
        or: [
          { associatedTawk_localId: { exists: true } }
          { associatedExternalTawk_id: { exists: true } }
        ]
      }
      sort: { field: createdAt, direction: desc }
      limit: 100
      nextToken: $nextPageToken
    ) {
      nextToken
      items {
        ...PostInfoV2WithDerivatives
      }
    }
  }
`;

export const FetchUserAllPostsPaginatedV2 = gql`
  ${PostInfoV2WithDerivatives}
  query FetchUserAllPostsPaginated($userSub: String!, $nextPageToken: String) {
    searchPosts(
      filter: { ownerSub: { eq: $userSub } }
      sort: { field: createdAt, direction: desc }
      limit: 100
      nextToken: $nextPageToken
    ) {
      nextToken
      items {
        ...PostInfoV2WithDerivatives
      }
    }
  }
`;

export const FetchUserPlaylistsV2 = gql`
  ${PostCollectionInfoV2}
  query FetchUserPlaylists($userSub: String!, $nextPageToken: String) {
    getUser(sub: $userSub) {
      postCollections(nextToken: $nextPageToken, sortDirection: DESC) {
        items {
          ...PostCollectionInfoV2
        }
        nextToken
      }
    }
  }
`;

export const FetchUserFromUserHandleV2 = gql`
  ${UserInfoV2}
  query FetchUserFromUserHandle($userHandleStandardForm: String!) {
    getUserHandle(standardForm: $userHandleStandardForm) {
      owner {
        ...UserInfoV2
      }
    }
  }
`;
